import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12985a56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modale-overlay" }
const _hoisted_2 = { class: "modale-card d-flex flex-column p-4" }
const _hoisted_3 = {
  key: 0,
  class: "modale-text mb-3"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "modale-text mb-3" }, "Une erreur s'est produite", -1))
const _hoisted_5 = {
  key: 0,
  class: "error"
}
const _hoisted_6 = { class: "d-flex flex-row justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.errorToDisplay && _ctx.errorToDisplay.message === 'Customer already exist.')
        ? (_openBlock(), _createElementBlock("label", _hoisted_3, "Téléphone ou mail déjà existant. A modifier pour enregistrer le client."))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_4,
            _createElementVNode("label", {
              class: "modale-text display-more mb-3",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.displayMoreInformations = !_ctx.displayMoreInformations))
            }, "Plus d'informations"),
            (_ctx.displayMoreInformations)
              ? (_openBlock(), _createElementBlock("pre", _hoisted_5, "                    " + _toDisplayString(JSON.parse(JSON.stringify(_ctx.errorToDisplay))) + "\n                ", 1))
              : _createCommentVNode("", true)
          ], 64)),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "btn btn-primary modale-button mx-2",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.validation && _ctx.validation(...args)))
        }, "Ok")
      ])
    ])
  ]))
}